import { dateFormatter } from "./helpers";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";

import baseChartFactory from "./base.echarts";

const tooltipDateFormatter = dateFormatter("s");

const formatterAxisPointer = v => {
	if (v.axisDimension === "x")
		return tooltipDateFormatter(v.value);

	return v.value.toFixed(2);
};

/**
 * @param {string[]} legend
 * @param {object[]} series Cada série representa uma linha no gráfico.
 * @param {string} series[].name nome na legenda
 * @param {'line'} series[].type
 * @param {string} series[].symbol
 * @param {number} series[].symbolSize
 * @param {object[]} series[].data valores da série temporal
 * @param {number} series[].data[].name timestamp
 * @param {[number, number]} series[].data[].value array de [timestamp, valor]
 * @param {'h'|'d'|'m'} grouping
 * @param {function} [toggleMarkLine]
 */
export function optionsFactory (title, legend, series, grouping = "f", toggleMarkLine, digitalCount = null) {
	return {
		...baseChartFactory({
			title,
			legend,
			series,
			yAxisZoom: true,
			toggleMarkLine
		}),
		axisPointer: {
			type: "cross",
			label: {
				formatter: formatterAxisPointer
			}
		},
		xAxis : [{
			type: "time",
			show: digitalCount > 0 || digitalCount === null,
			axisLabel: {
				formatter: dateFormatter(grouping)
			}
		},
		...(digitalCount !== null ? [{
			type: "time",
			show: true,
			axisLabel: {
				formatter: dateFormatter(grouping)
			},
			gridIndex: 1
		}] : [])]
	};
}

export function optionsFactoryFreq (title, legend, series, categorias, toggleMarkLine) {
	return {
		...baseChartFactory({
			title,
			legend,
			series,
			yAxisZoom: true,
			toggleMarkLine
		}),
		grid: {
			top: 65,    // espaço para a barra horizontal de zoom em cima
			left: 80,
			right: 75,
			bottom: 65  // espaço para legenda / margens
		},
		xAxis: [
			{
				type: "category",
				data: categorias,
				axisLabel: { show: false }
			}
		],
		yAxis: [
			{
				type: "value",
				axisLabel: { show: false }
			}
		],
		dataZoom: [
			// Barra horizontal em cima do gráfico
			{
				type: "slider",
				xAxisIndex: 0,
				height: 20,
				top: 30,          // acima do gráfico
				filterMode: "filter"
			},
			// Barra vertical à direita
			{
				type: "slider",
				yAxisIndex: 0,
				width: 20,
				right: 30,
				filterMode: "filter"
			},
			// Zoom interno
			{ type: "inside", xAxisIndex: 0, filterMode: "filter" },
			{ type: "inside", yAxisIndex: 0, filterMode: "filter" }
		]
	};
}


